module.exports = __webpack_public_path__ + "media/tape-nav/community-referral-icon-02b6db91.svg";